import React, { useRef, useEffect, useCallback } from "react";
import classNames from "classnames";
import { BtnUi, Icon, CarouselCard1Ui } from "~/components";
import { useHasScroll } from "./useHasScroll";
import { useScrollTo } from "./useScrollTo";
import { useShowButtons } from "./useShowButtons";
import { useInfiniteScroll } from "./useInfiniteScroll";
import styles from "./CarouselUi.module.css";

export const CarouselUi = ({
  className,
  allPassions,
  passions,
  getCardView,
  alwaysShowButtons = false,
  "data-testid": testId = "carousel-ui",
}) => {
  const carouselRef = useRef(null);
  const carouselChildren = useInfiniteScroll(carouselRef, passions);
  const hasScroll = useHasScroll(carouselRef, carouselChildren);
  const scrollTo = useScrollTo(carouselRef);
  const { mountButtons, hidePrev, hideNext } = useShowButtons({
    childrenCount: carouselChildren,
    hasScroll,
    isStart: false,
    isEnd: false,
    alwaysShowButtons,
  });

  // Scroll on arrows
  const onArrows = useCallback(
    ({ key }) => {
      key === "ArrowLeft" && scrollTo(-300);
      key === "ArrowRight" && scrollTo(300);
    },
    [scrollTo],
  );

  useEffect(() => {
    window.addEventListener("keyup", onArrows);
    return () => window.removeEventListener("keyup", onArrows);
  }, [onArrows]);

  return (
    <div className={classNames(styles.layout, className)} data-testid={testId}>
      {mountButtons && (
        <BtnUi
          data-testid="carousel-previous"
          aria-label="Scroll to previous items"
          className={classNames(styles.btn, styles.btnLeft, {
            [styles.btnHidden]: hidePrev,
            [styles.btnNone]: !alwaysShowButtons,
          })}
          onClick={scrollTo.bind(this, -300)}
          disabled={hidePrev}
        >
          <Icon name="arrowRightNoLine" inverse={true} />
        </BtnUi>
      )}
      <div className={styles.carousel} ref={carouselRef} data-testid="carousel-viewport">
        <div className={styles.carouselInner}>
          {carouselChildren.map((item, i) => {
            if (getCardView) {
              return getCardView(item, i);
            }

            return (
              <CarouselCard1Ui key={i} item={item} allPassions={allPassions} />
            );
          })}
        </div>
      </div>
      {mountButtons && (
        <BtnUi
          data-testid="carousel-next"
          aria-label="Scroll to next items"
          className={classNames(styles.btn, styles.btnRight, {
            [styles.btnHidden]: hideNext,
            [styles.btnNone]: !alwaysShowButtons,
          })}
          onClick={scrollTo.bind(this, 300)}
          disabled={hideNext}
        >
          <Icon name="arrowRightNoLine" />
        </BtnUi>
      )}
    </div>
  );
};
